import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../contexts/AuthContext';
import { fetchLoggedOutMenuId, fetchMenuItems, fetchMenus } from './menu.api';

export const useMenusQuery = () => {
  const { isLoggedIn } = useAuth();
  return useQuery({
    queryKey: ['menus'],
    queryFn: fetchMenus,
    enabled: isLoggedIn,
  });
};

export const useLoggedInMenuIdQuery = (menuId: number | undefined, isPaying: boolean) => useQuery({
  queryKey: ['loggedInMenu', menuId],
  queryFn: () => fetchMenuItems(menuId!, false),
  enabled: !!menuId && isPaying,
});

export const useLoggedOutMenuIdQuery = () => {
  const { isLoggedIn } = useAuth();
  return useQuery<number | undefined>({
    queryKey: ['loggedOutMenuId'],
    queryFn: fetchLoggedOutMenuId,
    enabled: !isLoggedIn,
  });
};

export const useMenuItemsQuery = (loggedInMenuId?: number) => {
  const { data: loggedOutMenuId } = useLoggedOutMenuIdQuery();
  const { isLoggedIn } = useAuth();

  const menuId = isLoggedIn ? loggedInMenuId : loggedOutMenuId;

  return useQuery({
    queryKey: ['menuItems', menuId, isLoggedIn],
    queryFn: () => {
      if (!menuId) {
        throw new Error('menuId is required');
      }
      return fetchMenuItems(menuId, !isLoggedIn);
    },
    enabled: !!menuId,
  });
};
